import script from "./posterShare.vue?vue&type=script&setup=true&lang=js"
export * from "./posterShare.vue?vue&type=script&setup=true&lang=js"

import "./posterShare.vue?vue&type=style&index=0&id=fdcefa4a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdcefa4a"]])

export default __exports__